import {
  HRMonthly_Review_Summary,
  HRMonthly_Review_Atrributes,
} from "../../Server/ApiV2";

// HR Monthly Evaluation Head Summary
export const onGetHRMonthly_Review_Summary = async (postData) => {
  try {
    const response = await HRMonthly_Review_Summary(postData);
    return response;
  } catch (err) {
    console.error("An error occurred:", err);
    return null;
  }
};

// HR Monthly Evaluation Head Summary
export const onGetHRMonthly_Review_Atrributes = async () => {
  try {
    const response = await HRMonthly_Review_Atrributes();
    return response;
  } catch (err) {
    console.error("An error occurred:", err);
    return null;
  }
};
